import React from 'react';
import {Dialog, DialogTitle, DialogContent, DialogActions} from '@epic-ui/epic/src/index';
import {Message, Button} from 'epic-diesel-common';

interface Props {
    open: boolean;
    body: string;
    title: string;
    onClose: () => void;
}

export const AgreementDialog: React.FunctionComponent<Props> = props => (
    <Dialog open={props.open} fullWidth={true}>
        <DialogTitle>{props.title}</DialogTitle>
        <DialogContent>
            <div dangerouslySetInnerHTML={{__html: props.body}} />
        </DialogContent>
        <DialogActions>
            <Button onClick={props.onClose} theme="dark">
                <Message code="epic.affiliate.common.close" />
            </Button>
        </DialogActions>
    </Dialog>
);
